import { IReducerAction } from 'src/interfaces/redux';
import { APPLICATION_EVENT_TYPES, EVENT_TYPES } from 'src/interfaces/enums';

export type AvailableCsatEvent = {
  [key in EVENT_TYPES | APPLICATION_EVENT_TYPES]: boolean;
};

export interface ICsatState {
  isLoaded: boolean;
  availableEventsCsat: Partial<AvailableCsatEvent>;
}

export const csatInitialState: ICsatState = {
  isLoaded: false,
  availableEventsCsat: {} as AvailableCsatEvent,
};

export enum CsatActionTypes {
  SET_CSAT_AS_LOADED = 'CSAT/SET_CSAT_AS_LOADED',
  SET_CSAT_AVAILABLE_EVENTS = 'CSAT/SET_CSAT_AVAILABLE_EVENTS',
  REMOVE_CSAT_AVAILABLE_EVENT = 'CSAT/REMOVE_CSAT_AVAILABLE_EVENT',
}

export type ICsatAction = IReducerAction<CsatActionTypes>;

export default function csatReducer(state: ICsatState = csatInitialState, action: ICsatAction) {
  switch (action.type) {
    case CsatActionTypes.SET_CSAT_AS_LOADED:
      return { ...state, isLoaded: true };
    case CsatActionTypes.SET_CSAT_AVAILABLE_EVENTS:
      return { ...state, availableEventsCsat: action.payload };
    case CsatActionTypes.REMOVE_CSAT_AVAILABLE_EVENT: {
      const copyAvailableEventsCsat = { ...state.availableEventsCsat };
      delete copyAvailableEventsCsat[action.payload];
      return {
        ...state,
        availableEventsCsat: copyAvailableEventsCsat,
      };
    }
    default:
      return state;
  }
}
